/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SasUploadLinkResponse } from '../models/SasUploadLinkResponse';
import type { StayBookingDetail } from '../models/StayBookingDetail';
import type { TourDetail } from '../models/TourDetail';
import type { TourOverview } from '../models/TourOverview';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TourService {
    /**
     * Reserve a generated tour
     * @param tourId
     * @param sessionId
     * @param compoundTypes
     * @returns TourDetail OK
     * @throws ApiError
     */
    public static reserveTour(
        tourId: number,
        sessionId?: string,
        compoundTypes?: Array<string>,
    ): CancelablePromise<TourDetail> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/tours/{tourId}/reserve',
            path: {
                'tourId': tourId,
            },
            query: {
                'sessionId': sessionId,
                'compoundTypes': compoundTypes,
            },
        });
    }
    /**
     * Replace the site of a stay in a tour
     * @param tourId
     * @param stayId
     * @param newSiteId
     * @param compoundTypes
     * @param curationId
     * @returns TourDetail OK
     * @throws ApiError
     */
    public static replaceSite(
        tourId: number,
        stayId: number,
        newSiteId: number,
        compoundTypes?: Array<string>,
        curationId?: number,
    ): CancelablePromise<TourDetail> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/tours/{tourId}/mutations/stays/{stayId}/replace/site/{newSiteId}',
            path: {
                'tourId': tourId,
                'stayId': stayId,
                'newSiteId': newSiteId,
            },
            query: {
                'compoundTypes': compoundTypes,
                'curationId': curationId,
            },
        });
    }
    /**
     * Change duration of a stay in a tour
     * @param tourId
     * @param stayId
     * @param newFromDate The datetime is in UTC as milliseconds at midnight (example: 02.06.2023 -> 1685664000000), to create a timestamp in this format use https://www.timestamp-converter.com
     * @param newToDate The datetime is in UTC as milliseconds at midnight (example: 02.06.2023 -> 1685664000000), to create a timestamp in this format use https://www.timestamp-converter.com
     * @param compoundTypes
     * @returns TourDetail OK
     * @throws ApiError
     */
    public static changeStayDuration(
        tourId: number,
        stayId: number,
        newFromDate: number,
        newToDate: number,
        compoundTypes?: Array<string>,
    ): CancelablePromise<TourDetail> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/tours/{tourId}/mutations/stays/{stayId}/change/duration/{newFromDate}/{newToDate}',
            path: {
                'tourId': tourId,
                'stayId': stayId,
                'newFromDate': newFromDate,
                'newToDate': newToDate,
            },
            query: {
                'compoundTypes': compoundTypes,
            },
        });
    }
    /**
     * Change additional information from a vanlifer of a stay in a tour
     * @param tourId
     * @param stayId
     * @param newArrivalTime
     * @param newComment
     * @param compoundTypes
     * @returns TourDetail OK
     * @throws ApiError
     */
    public static changeStayAdditionalInformation(
        tourId: number,
        stayId: number,
        newArrivalTime: string,
        newComment: string,
        compoundTypes?: Array<string>,
    ): CancelablePromise<TourDetail> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/tours/{tourId}/mutations/stays/{stayId}/change/additional-information',
            path: {
                'tourId': tourId,
                'stayId': stayId,
            },
            query: {
                'newArrivalTime': newArrivalTime,
                'newComment': newComment,
                'compoundTypes': compoundTypes,
            },
        });
    }
    /**
     * Toggle a user's like for a tour.
     * @param tourId
     * @param liked
     * @returns boolean Successfully toggled.
     * @throws ApiError
     */
    public static toggleTourLike(
        tourId: number,
        liked: boolean,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/tours/{tourId}/likes/toggle',
            path: {
                'tourId': tourId,
            },
            query: {
                'liked': liked,
            },
        });
    }
    /**
     * Cancel a booked tour
     * @param tourId
     * @returns TourDetail OK
     * @throws ApiError
     */
    public static cancelTour(
        tourId: number,
    ): CancelablePromise<TourDetail> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/tours/{tourId}/cancel',
            path: {
                'tourId': tourId,
            },
        });
    }
    /**
     * Book a reserved tour
     * @param tourId
     * @returns TourDetail OK
     * @throws ApiError
     */
    public static bookTour(
        tourId: number,
    ): CancelablePromise<TourDetail> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/tours/{tourId}/book',
            path: {
                'tourId': tourId,
            },
        });
    }
    /**
     * Gets an existing access-key or null if none is present.
     * @param tourId
     * @returns string Successfully retrieved access-key.
     * @throws ApiError
     */
    public static getAccessKey(
        tourId: number,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/tours/{tourId}/accessKey',
            path: {
                'tourId': tourId,
            },
            errors: {
                403: `User is not authorized to retrieve access-key. `,
            },
        });
    }
    /**
     * Creates or updates access-key for a tour.
     * @param tourId
     * @returns string Successfully created or updated access-key.
     * @throws ApiError
     */
    public static createOrUpdateAccessKey(
        tourId: number,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/tours/{tourId}/accessKey',
            path: {
                'tourId': tourId,
            },
            errors: {
                403: `User is not authorized to change access-key. `,
                404: `Tour does not exist.`,
            },
        });
    }
    /**
     * Deletes an access-key.
     * @param tourId
     * @returns void
     * @throws ApiError
     */
    public static deleteAccessKey(
        tourId: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/tours/{tourId}/accessKey',
            path: {
                'tourId': tourId,
            },
            errors: {
                403: `User is not authorized to delete access-key. `,
            },
        });
    }
    /**
     * Creates a SAS-link to upload an image for a tour.
     * @param tourId ID of the Tour.
     * @param fileExtension Extension of the image to be uploaded (jpg, jpeg, png, webp)
     * @returns SasUploadLinkResponse Successfully created.
     * @throws ApiError
     */
    public static getSasUploadLink(
        tourId: number,
        fileExtension: string,
    ): CancelablePromise<SasUploadLinkResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/tours/{tourId}/image/link',
            path: {
                'tourId': tourId,
            },
            query: {
                'fileExtension': fileExtension,
            },
            errors: {
                400: `Invalid file extension.`,
                403: `User is not authorized to create an upload-link for this tour.`,
            },
        });
    }
    /**
     * Update community attributes of tour. (name, description, Sharingmode)
     * @param tourId
     * @param name New name
     * @param description New description
     * @param sharingMode New Sharingmode
     * @param imageName New Image
     * @param fileExtension Extension of image (png/jpg/webp)
     * @returns TourDetail Successfully updated.
     * @throws ApiError
     */
    public static updateTourCommunityAttributes(
        tourId: number,
        name?: string,
        description?: string,
        sharingMode?: 'PRIVATE' | 'PUBLIC',
        imageName?: string,
        fileExtension?: string,
    ): CancelablePromise<TourDetail> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/tours/{tourId}/community',
            path: {
                'tourId': tourId,
            },
            query: {
                'name': name,
                'description': description,
                'sharingMode': sharingMode,
                'imageName': imageName,
                'fileExtension': fileExtension,
            },
            errors: {
                403: `User is not authorized to edit tour or user lacks entitlement to make tour public.`,
            },
        });
    }
    /**
     * Get existing tours
     * @param sessionId
     * @param vanliferId
     * @param tourStatus
     * @returns TourOverview OK
     * @throws ApiError
     */
    public static getTours(
        sessionId?: string,
        vanliferId?: number,
        tourStatus?: 'GENERATED' | 'TAGGED' | 'RESERVED' | 'BOOKED' | 'CANCELED',
    ): CancelablePromise<Array<TourOverview>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/tours',
            query: {
                'sessionId': sessionId,
                'vanliferId': vanliferId,
                'tourStatus': tourStatus,
            },
        });
    }
    /**
     * Get a existing tour
     * @param tourId
     * @param compoundTypes
     * @param accessKey
     * @returns TourDetail OK
     * @throws ApiError
     */
    public static getTour(
        tourId: number,
        compoundTypes?: Array<string>,
        accessKey?: string,
    ): CancelablePromise<TourDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/tours/{tourId}',
            path: {
                'tourId': tourId,
            },
            query: {
                'compoundTypes': compoundTypes,
                'accessKey': accessKey,
            },
        });
    }
    /**
     * Get stays between two timestamps
     * @param fromTimestamp The datetime is in UTC as milliseconds at midnight (example: 02.06.2023 -> 1685664000000), to create a timestamp in this format use https://www.timestamp-converter.com
     * @param toTimestamp The datetime is in UTC as milliseconds at midnight (example: 02.06.2023 -> 1685664000000), to create a timestamp in this format use https://www.timestamp-converter.com
     * @param hostId
     * @returns StayBookingDetail OK
     * @throws ApiError
     */
    public static getStaysBetween(
        fromTimestamp: number,
        toTimestamp: number,
        hostId: number,
    ): CancelablePromise<Array<StayBookingDetail>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/tours/stay/{fromTimestamp}/{toTimestamp}/{hostId}',
            query: {
                'fromTimestamp': fromTimestamp,
                'toTimestamp': toTimestamp,
                'hostId': hostId,
            },
        });
    }
    /**
     * Gets random ongoing tours (12)
     * @returns TourOverview Success
     * @throws ApiError
     */
    public static getOngoingTours(): CancelablePromise<Array<TourOverview>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/tours/ongoing',
        });
    }
    /**
     * Gets most liked tours (12)
     * @returns TourOverview Success
     * @throws ApiError
     */
    public static getMostLikedTours(): CancelablePromise<Array<TourOverview>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/tours/most-liked',
        });
    }
    /**
     * Get generated tours by algorithm
     * @param regionId
     * @param fromDate The datetime is in UTC as milliseconds at midnight (example: 02.06.2023 -> 1685664000000), to create a timestamp in this format use https://www.timestamp-converter.com
     * @param toDate The datetime is in UTC as milliseconds at midnight (example: 02.06.2023 -> 1685664000000), to create a timestamp in this format use https://www.timestamp-converter.com
     * @param sessionId
     * @param compoundTypes
     * @param curationId
     * @returns TourOverview OK
     * @throws ApiError
     */
    public static generateTours(
        regionId: number,
        fromDate: number,
        toDate: number,
        sessionId?: string,
        compoundTypes?: Array<string>,
        curationId?: number,
    ): CancelablePromise<Array<TourOverview>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/tours/generate',
            query: {
                'sessionId': sessionId,
                'regionId': regionId,
                'fromDate': fromDate,
                'toDate': toDate,
                'compoundTypes': compoundTypes,
                'curationId': curationId,
            },
        });
    }
    /**
     * Get all public tours of a user
     * @param communityName
     * @returns TourOverview Success
     * @throws ApiError
     */
    public static getPublicToursForVanlifer(
        communityName: string,
    ): CancelablePromise<Array<TourOverview>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/community/{communityName}/tours/public',
            path: {
                'communityName': communityName,
            },
        });
    }
    /**
     * Get all public tours liked by a user
     * @param communityName
     * @returns TourOverview Success
     * @throws ApiError
     */
    public static getPublicToursByUserLiked(
        communityName: string,
    ): CancelablePromise<Array<TourOverview>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/community/{communityName}/tours/likes',
            path: {
                'communityName': communityName,
            },
        });
    }
}
